<template>
  <div class="musashi_layout" v-if="user">
    <Loader />
    <GlobalModals />
    <div class="main_nav bg-white">
      <div class="container-xl">
        <TopNavBar />
      </div>
    </div>
    <div class="main-content container-xl mt-5" :class="container_class">
      <div class="crumb">
        <slot name="breadcrumb"></slot>
      </div>
      <slot name="default"></slot>
    </div>
  </div>
</template>
<script lang="ts">
import Loader from '@app/components/Loader.vue'
import GlobalModals from '@/components/GlobalModals.vue'
import { useUserStore } from '@app/stores/UserStore'
import { useFeatureStore } from '@app/stores/FeatureStore'

import { mapState } from 'pinia'
import { koalaTrack } from '@lib/koala'

import TopNavBar from '@app/components/TopNavBar.vue'

export default {
  components: { Loader, TopNavBar, GlobalModals },
  computed: {
    ...mapState(useUserStore, ['user', 'true_user']),
    ...mapState(useFeatureStore, ['isFeatureEnabled']),
    container_class() {
      if (this.true_user) return 'padit'
      return null
    },
  },
  mounted() {
    this.changeTheme()
    koalaTrack('App Viewed', { path: this.$router.currentRoute.path })
  },
  methods: {
    changeTheme() {
      const hmtlEl = document.documentElement
      const themeClass = this.isFeatureEnabled('v2_theme') ? 'v2-theme' : 'v1-theme'

      if (hmtlEl.className.includes('app')) {
        hmtlEl.className = `app ${themeClass}`
      }
    },
  },
}
</script>
